var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.status ? 'Enabled' : 'Disabled',"current_value":_vm.status},on:{"update:current_value":function($event){_vm.status=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }